import { render } from "./SurahBorder.vue?vue&type=template&id=695e4efe"
import script from "./SurahBorder.vue?vue&type=script&lang=js"
export * from "./SurahBorder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__